// extracted by mini-css-extract-plugin
export var avatar = "_pm-3";
export var avatarContainer = "_pm-2";
export var avatarSpacer = "_pm-5";
export var avatarSpacerContainer = "_pm-4";
export var avatarStackContainer = "_pm-1";
export var bubble = "_pm-0";
export var remainderBubble = "_pm-6";